import { Countdown } from 'components/countdown';
import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';

import {
  getPlayerInfo,
  getTasks,
  getTasksManager,
  getVacationManager,
  getTasksPendingApprovalParticipants,
  getTasksManagerEcoa,
} from 'services/dashboard.service';
import { GetTaskLevelLabel, GetTaskStatusLabel } from 'utils/strings';

import { User, VacationManagerInterface } from 'types/user';
import VacationManagerModal from 'components/vacation-manager-modal';
import { useModal } from 'context/ModalContext';
import { gravarLateralidade } from 'utils/lateralidade';
import { getStorageItem, removeStorageItem } from 'utils/storage';
import { AiOutlineWarning } from 'react-icons/ai';
import Tippy from '@tippyjs/react';
import { BiInfoCircle } from 'react-icons/bi';
import { findLateralMenagers } from 'services/profile.service';
import ModalEquipeLateral from 'pages/MinhaEquipe/components/ModalEquipeLateral';
import { UserNeedingApprovalModal } from 'components/user-needing-approval-modal';
import { TasksPendingApprovalParticipantsModal } from 'components/tasks-pending-approval-participants-modal';
import { LuBell } from 'react-icons/lu';
import { useServerNow } from '../server-clock';
import {
  agendaCaption,
  agendaDeadline,
  DeadlineNote,
  PhaseAgenda,
  phaseStep,
  PhaseStep,
  ProgramItemRow,
  ProgramSection,
  registrationMeta,
} from './program-section';

interface Props {
  /** O ciclo selecionado está fechado: a seção só acompanha, sem cadastro, agenda nem prazo (ECOA-01 a ECOA-03). */
  cycleIsClosed?: boolean;
}

export function TaskCyclesEcoa({ cycleIsClosed = false }: Props) {
  const navigate = useNavigate();
  const { user, userInfo, cycles, currentCycle, realCycle, cycleSelected } = useAuth();
  const { showModal, closeModal } = useModal();
  const [canRegister, setCanRegister] = useState(true);

  // const [tasks, setTasks] = useState<any>();
  const [currentTaskCycle, setCurrentTaskCycle] = useState<any>();
  const [loadingTasks, setLoadingTasks] = useState(true);
  const [taskCycles, setTaskCycles] = useState<any>();
  const [myTasks, setMyTasks] = useState<any[]>();
  const [otherTasks, setOtherTasks] = useState<any[]>();

  const [evaluateTasks, setEvaluateTasks] = useState<any[]>();
  const [playerInfo, setPlayerInfo] = useState<any>();
  const [cycleActive, setCycleActive] = useState<string>();
  const [evaluateCycleActive, setEvaluateCycleActive] = useState<string>();
  const [lateralManagers, setLateralManagers] = useState<User[]>();
  const [showModalLateral, setShowModalLateral] = useState(false);
  const [isExperied, setIsExperied] = useState(false);
  const [isStarting, setIsStarting] = useState(false);

  // Relógio único da Home (DCE-35, DCE-36); 0 enquanto a hora do servidor não chegou.
  const realDatetime = useServerNow();
  const hasTime = realDatetime > 0;

  const activeCycleObj = useMemo(() => taskCycles?.find((item: any) => item._id === cycleActive), [cycleActive, taskCycles]);

  const evaluateActiveCycleObj = useMemo(
    () => taskCycles?.find((item: any) => item._id === evaluateCycleActive),
    [evaluateCycleActive, taskCycles],
  );

  const activeCycleSelectObj = useMemo(
    () => realCycle?.find((item: any) => item._id === evaluateActiveCycleObj?.cycleId),
    [evaluateActiveCycleObj?.cycleId, realCycle],
  );

  const taskPerCycle: any = useMemo(() => {
    if (!Array.isArray(myTasks) || !taskCycles?.length || !cycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === cycleActive);
    const tasks = myTasks.filter(
      (item: any) => item.created >= cycle.date_start && item.created <= cycle.date_finish && item.status !== 'arquivado',
    );

    return tasks?.length ? tasks[0] : null;
  }, [cycleActive, myTasks, taskCycles]);

  const evaluateTaskPerCycle: any = useMemo(() => {
    if (!Array.isArray(evaluateTasks) || !taskCycles?.length || !evaluateCycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === evaluateCycleActive);

    const tasks = evaluateTasks;

    return tasks?.length ? tasks[tasks.length - 1] : null;

    // let tasksFiltered = tasks.filter((item: any) => !!isCurrentEvaluator(item));

    // if (tasksFiltered?.length) {
    //   tasksFiltered = tasksFiltered[tasksFiltered.length - 1];
    // } else {
    //   tasksFiltered = tasks[tasks.length - 1];
    // }

    // console.log(tasksFiltered);

    // return !!tasksFiltered ? tasksFiltered : null;
  }, [evaluateCycleActive, evaluateTasks, taskCycles]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!evaluateActiveCycleObj || !realDatetime) return null;

    if (
      realDatetime > evaluateActiveCycleObj.evaluation_ecoa_days_step2_start &&
      realDatetime < evaluateActiveCycleObj.evaluation_ecoa_days_step2_finish
    ) {
      // Etapa 2
      return 2;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step3_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step4_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step4_finish
    ) {
      // Etapa 4
      return 4;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_pitStop_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step5_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step5_finish
    ) {
      // Etapa 5
      return 5;
    } else {
      return 0;
    }
  }, [evaluateActiveCycleObj, realDatetime]);

  const getPlayerStep = (task: any) => {
    if (playerInfo.ecoa === 'TUTOR' || playerInfo.ecoa === 'COORDENADOR') {
      if (
        (playerInfo.ecoa === 'TUTOR' || playerInfo.ecoa === 'COORDENADOR') &&
        (task.status === 'ciente' || task.status === 'aguardando')
      ) {
        return 2;
      }

      if ((playerInfo.ecoa === 'TUTOR' || playerInfo.ecoa === 'COORDENADOR') && task.status === 'aprovado') {
        return 5;
      }
    }

    return 0;
  };

  const htmlCountdownEvaluation = useMemo(() => {
    if (
      !evaluateActiveCycleObj ||
      (!getActiveEvaluationStep && getActiveEvaluationStep !== 0) ||
      !playerInfo ||
      !Array.isArray(evaluateTasks) ||
      !taskCycles?.length ||
      !evaluateCycleActive
    ) {
      setIsExperied(true);

      return <></>;
    }

    const cycle = taskCycles.find((cycle: any) => cycle._id === evaluateCycleActive);

    const tasks: any[] = evaluateTasks;
    if (evaluateActiveCycleObj.status === 'open') {
      setIsExperied(false);
      return (
        <>
          <span>
            O período de avaliação desta fase inicia em:{' '}
            <strong className="font-semibold whitespace-nowrap">
              <Countdown urgentClassName="text-urgent" hideIcon key="missao" deadline={new Date(evaluateActiveCycleObj.date_finish)} />
            </strong>
          </span>
        </>
      );
    } else if (evaluateActiveCycleObj.status === 'evaluation') {
      if (tasks.length) {
        const userTaskStep: number[] = tasks
          .map(task => (typeof getPlayerStep(task) === 'number' ? (getPlayerStep(task) as number) : 0))
          .sort(() => -1);

        if (userTaskStep.includes(getActiveEvaluationStep) || (getActiveEvaluationStep === 5 && userTaskStep.includes(2))) {
          const date_start =
            getActiveEvaluationStep === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_start
              : evaluateActiveCycleObj?.date_evaluation_step5_start;

          const date_finish =
            getActiveEvaluationStep === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_finish
              : evaluateActiveCycleObj?.date_evaluation_step5_finish;

          setIsExperied(false);

          return (
            <>
              <span>
                O período de apreciação deste nível termina em:{' '}
                <strong className="font-semibold whitespace-nowrap">
                  <Countdown urgentClassName="text-urgent" hideIcon key="missao" deadline={new Date(date_finish)} />
                </strong>
              </span>
            </>
          );
        } else {
          const hasAfter = userTaskStep?.find((x: number) => x > (getActiveEvaluationStep as number));

          const date_start =
            hasAfter === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_start
              : hasAfter === 3
                ? evaluateActiveCycleObj?.date_evaluation_step5_start
                : hasAfter === 4
                  ? evaluateActiveCycleObj?.date_evaluation_step5_start
                  : hasAfter === 4.1
                    ? evaluateActiveCycleObj?.date_evaluation_step5_start
                    : evaluateActiveCycleObj?.date_evaluation_step5_start;

          const date_finish =
            hasAfter === 2
              ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_finish
              : hasAfter === 3
                ? evaluateActiveCycleObj?.date_evaluation_step5_finish
                : hasAfter === 4
                  ? evaluateActiveCycleObj?.date_evaluation_step5_finish
                  : hasAfter === 4.1
                    ? evaluateActiveCycleObj?.date_evaluation_step5_finish
                    : evaluateActiveCycleObj?.date_evaluation_step5_finish;

          if (!!hasAfter) {
            setIsExperied(false);
            setIsStarting(true);
            return (
              <>
                <span>
                  O período de apreciação começa em:{' '}
                  <strong className="font-semibold whitespace-nowrap">
                    <Countdown urgentClassName="text-urgent" hideIcon key="missao" deadline={new Date(date_start)} />
                  </strong>
                </span>
              </>
            );
          } else {
            setIsExperied(true);
            return <></>;
          }
        }
      } else {
        const codEtapa =
          playerInfo.cod_etapa === 2
            ? 2
            : playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3
              ? 3
              : playerInfo.cod_etapa === 4
                ? 4
                : playerInfo.cod_etapa === 5
                  ? 5
                  : null;

        if (codEtapa) {
          if (getActiveEvaluationStep === codEtapa) {
            const date_finish =
              getActiveEvaluationStep === 2
                ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_finish
                : getActiveEvaluationStep === 3
                  ? evaluateActiveCycleObj?.date_evaluation_step3_finish
                  : getActiveEvaluationStep === 4
                    ? evaluateActiveCycleObj?.date_evaluation_step4_finish
                    : evaluateActiveCycleObj?.date_evaluation_step5_finish;

            setIsExperied(false);
            return (
              <span>
                O período de apreciação deste nível termina em:{' '}
                <strong className="font-semibold whitespace-nowrap">
                  <Countdown urgentClassName="text-urgent" hideIcon key="missao" deadline={new Date(date_finish)} />
                </strong>
              </span>
            );
          } else {
            if (getActiveEvaluationStep < codEtapa) {
              const date_start =
                codEtapa === 2
                  ? evaluateActiveCycleObj?.evaluation_ecoa_days_step2_start
                  : codEtapa === 3
                    ? evaluateActiveCycleObj?.date_evaluation_step3_start
                    : codEtapa === 4
                      ? evaluateActiveCycleObj?.date_evaluation_step4_start
                      : evaluateActiveCycleObj?.date_evaluation_step5_start;
              setIsExperied(false);
              setIsStarting(true);
              return (
                <span>
                  O período de apreciação começa em:{' '}
                  <strong className="font-semibold whitespace-nowrap">
                    <Countdown urgentClassName="text-urgent" hideIcon key="missao" deadline={new Date(date_start)} />
                  </strong>
                </span>
              );
            } else {
              setIsExperied(true);
              return <></>;
            }
          }
        } else {
          setIsExperied(true);
          return <></>;
        }
      }
    } else {
      setIsExperied(true);
      return <></>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateActiveCycleObj, evaluateCycleActive, evaluateTasks, getActiveEvaluationStep, playerInfo, taskCycles]);

  const hasToEvaluate = useMemo(() => {
    if (!Array.isArray(evaluateTasks)) {
      return false;
    }

    const tasks = evaluateTasks.filter((item: any) => {
      if (!getActiveEvaluationStep) return false;
      const lastManager = item?.evaluator?.length ? item.evaluator[item.evaluator.length - 1] : item.original_manager;

      // if (lastManager !== playerInfo?._id) {
      //   return false;
      // }

      console.log(getActiveEvaluationStep);

      if (
        getActiveEvaluationStep >= 5 &&
        (item.status === 'concluido' || item.status === 'dobrado' || item.status === 'concluidoAuto')
      ) {
        return false;
      }

      if (getActiveEvaluationStep === 2 && item.status === 'aprovado') {
        return false;
      }

      if (getActiveEvaluationStep > 2 && item.status === 'aguardando') {
        return false;
      }

      if (
        item.status === 'ciente' ||
        item.status === 'concluido' ||
        item.status === 'concluidoAuto' ||
        item.status === 'dobrado'
      ) {
        return false;
      }

      if (
        getActiveEvaluationStep &&
        getActiveEvaluationStep > 2 &&
        lastManager === playerInfo?._id &&
        (item.status === 'concluidoAuto' || item.status === 'concluido' || item.status === 'selo')
      ) {
        return false;
      }

      return true;
    });

    console.log(tasks.length);

    return tasks.length > 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateTasks, getActiveEvaluationStep, playerInfo]);

  const showHasEvaluated = useMemo(() => {
    // !isStarting
    if (!isExperied && !hasToEvaluate) {
      return true;
    }

    if (!hasToEvaluate && getActiveEvaluationStep === 2) {
      return true;
    }

    return false;
  }, [hasToEvaluate, isExperied, getActiveEvaluationStep]);

  useEffect(() => {
    async function getUserInfo() {
      try {
        const _playerInfo: any = userInfo;

        if (_playerInfo) {
          setPlayerInfo(_playerInfo);
          setCanRegister(!!_playerInfo?.ecoa && _playerInfo?.ecoa === 'INTEGRANTE');

          // Calendário já lido pelo AuthContext (`find/calendar_v2`, mesma ordem de getTaskCycles()) (DCE-34).
          const taskCycleResults: any[] = cycles ?? [];
          setTaskCycles(taskCycleResults);

          // Pode cadastrar
          if (!!_playerInfo?.ecoa && _playerInfo?.ecoa === 'INTEGRANTE') {
            const data = await getTasks(user?._id, null, null, true);

            const my_tasks = data.filter((item: any) => item.owner === user?._id);

            setMyTasks(my_tasks);
            // As demais são ações de que a pessoa participa: contam no rodapé (HOME-26).
            setOtherTasks(data.filter((item: any) => item.owner !== user?._id));

            const currentCycle = taskCycleResults.find((item: any) => item.status === 'open');

            setCycleActive(currentCycle?._id || taskCycleResults[0]._id);
          }

          // Gestor

          if (!!_playerInfo?.ecoa && (_playerInfo?.ecoa === 'TUTOR' || _playerInfo?.ecoa === 'COORDENADOR')) {
            const currentStage = taskCycleResults.find((item: any) => item.status === 'evaluation');
            const stageId = currentStage?._id || taskCycleResults[0]._id;
            const cycleObj = realCycle?.find(e => e._id === currentStage?.cycleId);
            const cycleId = currentCycle?._id || taskCycles.find((item: any) => item.type && item.type === 'month')?._id;

            const start =
              !!currentStage &&
              realDatetime >= currentStage?.date_evaluation_step5_start &&
              realDatetime <= currentStage?.date_evaluation_step5_finish &&
              !!cycleObj
                ? cycleObj.date_start
                : currentStage?._id === '67241c4a81985d067f49c740'
                  ? 1730174400000
                  : taskCycleResults.find((item: any) => item._id === cycleId)?.date_start;

            const end =
              currentStage &&
              realDatetime >= currentStage?.date_evaluation_step5_start &&
              realDatetime <= currentStage?.date_evaluation_step5_finish &&
              !!cycleObj
                ? cycleObj.date_end
                : taskCycleResults.find((item: any) => item._id === cycleId)?.date_finish;

            const data = await getTasksManagerEcoa(user?.extra.id, start, end);

            setEvaluateTasks(data);
            setEvaluateCycleActive(cycleId);
          }
        }

        setLoadingTasks(false);
      } catch (e) {
        console.log(e);
      }
    }

    if (user && !playerInfo && hasTime && realCycle && cycles) {
      getUserInfo();
    }
    // Só primitivos de player: nova referência de `user`/`userInfo` (refreshUser) não reavalia a
    // leitura (DCE-28).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerInfo, user?._id, userInfo?.chave, hasTime, realCycle, cycles]);

  function getDescription() {
    return (
      <p>
        Você possui acordo individual do tipo pré-definido na Plataforma Conexão e por isso, não realiza o cadastramento, mas pode
        participar de ações de outras equipes, participando da premiação coletiva. <br />
        <br />
        Para premiação individual a pontuação final das Ações ECOA será pelo Placar Consolidado da Plataforma Conexão.
      </p>
    );
  }

  // Etapas da "Agenda da fase" (HOME-21) de um mês: cadastramento, ciência e bonificação dele.
  function agendaStepsOf(stage: any): PhaseStep[] {
    if (!playerInfo || !stage) return [];

    return [
      phaseStep('Cadastramento', stage.date_start, stage.date_finish),
      phaseStep('Ciência e validação', stage.evaluation_ecoa_days_step2_start, stage.evaluation_ecoa_days_step2_finish),
      phaseStep('Bonificação', stage.date_evaluation_step5_start, stage.date_evaluation_step5_finish),
    ];
  }

  // Uma só agenda para todos os papéis (HOME-21): o mês em apreciação, que é onde a "Ciência e
  // validação" está correndo; sem ele, o mês aberto para cadastro; sem os dois, o primeiro do calendário.
  const agendaStage =
    taskCycles?.find((item: any) => item.status === 'evaluation') ||
    taskCycles?.find((item: any) => item.status === 'open') ||
    taskCycles?.[0];
  const agendaSteps = agendaStepsOf(agendaStage);
  const agenda = <PhaseAgenda steps={agendaSteps} caption={agendaCaption(agendaStage?.title, cycleSelected?.title)} />;

  // Ações do mês ativo: as cadastradas pela pessoa e as de que participa (HOME-26).
  const monthCounts = useMemo(() => {
    const inActiveMonth = (item: any) =>
      !!activeCycleObj &&
      item.created >= activeCycleObj.date_start &&
      item.created <= activeCycleObj.date_finish &&
      item.status !== 'arquivado';

    return {
      registered: (myTasks || []).filter(inActiveMonth).length,
      participations: (otherTasks || []).filter(inActiveMonth).length,
    };
  }, [activeCycleObj, myTasks, otherTasks]);

  // Com o ciclo fechado ninguém vê o prazo da agenda, e o integrante também não vê a agenda
  // (ECOA-03, ECOA-06). Com ele aberto, o prazo é o da agenda e as contagens do integrante são do
  // mês aberto para cadastro, o mesmo da chamada "neste mês" e do botão "Cadastrar ação" (HOME-26).
  const participantAgenda = cycleIsClosed ? undefined : agenda;
  const agendaNote = cycleIsClosed ? null : agendaDeadline(agendaSteps);
  const participantNote = agendaNote ? (
    <DeadlineNote>{ecoaFooterNote(agendaNote, monthCounts.registered, monthCounts.participations)}</DeadlineNote>
  ) : undefined;

  // Prazo de quem aprecia (tutor, coordenador) quando a contagem da apreciação não aparece (HOME-25).
  const appraiserNote = agendaNote ? <DeadlineNote>{agendaNote}</DeadlineNote> : undefined;

  const isIntegrante = !!playerInfo?.ecoa && playerInfo?.ecoa === 'INTEGRANTE';
  const isMonthOpen = activeCycleObj?.status === 'open' && !cycleIsClosed;

  const canRegisterNow =
    isIntegrante &&
    isMonthOpen &&
    activeCycleObj?._id !== '68af4da8458e527eaa788503' &&
    user?.extra?.actions !== false &&
    !playerInfo?.visualizador;

  const registerButton = (
    <Button
      variant="solido-destaque"
      size="sm"
      onClick={() => navigate('/acao-ecoa/cadastrar')}
      aria-label="Cadastrar ação ECOA. Abre modal"
    >
      Cadastrar ação
    </Button>
  );

  const followButton = (
    <Button variant="texto" size="sm" onClick={() => navigate('/acao-ecoa')} aria-label="Acompanhar ações ECOA">
      Acompanhar ações
    </Button>
  );

  // Chamada do integrante com o mês aberto, com ou sem ação no mês (HOME-28). O cadastro de
  // Ações ECOA não tem limite por mês, ao contrário do que o design escreve.
  const openMonthHeadline = 'Que tal cadastrar uma Ação ECOA neste mês?';
  const openMonthDescription = (
    <p>
      Registre o que a sua Ecoa realizou e acompanhe a apreciação do coordenador ou tutor.
      <br />
      <b>Lembre-se:</b> não há limite de Ações ECOA por mês nem de integrantes por ação.
    </p>
  );
  const followDescription = <p>Visualize suas Ações ECOA e acompanhe o status de apreciação.</p>;
  const isAppraiser = !!playerInfo?.ecoa && (playerInfo?.ecoa === 'TUTOR' || playerInfo?.ecoa === 'COORDENADOR');

  return (
    <>
      {loadingTasks && (
        <ProgramSection program="ecoa" name="Ações ECOA">
          <p role="status" className="text-sm text-content-soft">
            Carregando informações...
          </p>
        </ProgramSection>
      )}

      {/* Cadastro */}
      {!loadingTasks &&
        !!canRegister &&
        (!!taskPerCycle ? (
          <ProgramSection
            program="ecoa"
            name="Ações ECOA"
            headline={isIntegrante && isMonthOpen ? openMonthHeadline : undefined}
            description={isIntegrante && isMonthOpen ? openMonthDescription : followDescription}
            actions={
              <>
                {canRegisterNow && registerButton}
                {followButton}
              </>
            }
            note={participantNote}
          >
            {participantAgenda}

            <ProgramItemRow
              eyebrow="Sua última Ação ECOA"
              title={
                <>
                  <span className="screen-reader-text">Título da Ação: </span>
                  {taskPerCycle.title}
                </>
              }
              meta={registrationMeta({
                relation: 'Sua ação',
                detail: taskPerCycle.indicator?.nome,
                created: taskPerCycle.created,
              })}
              status={GetTaskLevelLabel(taskPerCycle.status)}
              statusLabel="Status da entrega"
              to="/acao-ecoa"
            />
          </ProgramSection>
        ) : (
          <ProgramSection
            program="ecoa"
            name="Ações ECOA"
            headline={
              isIntegrante && isMonthOpen
                ? openMonthHeadline
                : activeCycleObj?.status === 'closed' && isIntegrante
                  ? 'Você não possui Ação ECOA cadastrada nesta fase.'
                  : undefined
            }
            description={isIntegrante && isMonthOpen ? openMonthDescription : followDescription}
            actions={
              <>
                {canRegisterNow && registerButton}
                {followButton}
              </>
            }
            note={participantNote}
          >
            {participantAgenda}
          </ProgramSection>
        ))}

      {!loadingTasks &&
        isAppraiser &&
        (!!evaluateTaskPerCycle ? (
          <ProgramSection
            program="ecoa"
            name="Ações ECOA"
            headline={
              !isExperied && hasToEvaluate && !isStarting
                ? 'Você tem Ações ECOA esperando serem apreciadas!'
                : showHasEvaluated
                  ? 'Não há nenhuma Ação ECOA aguardando apreciação'
                  : undefined
            }
            description={
              showHasEvaluated ? undefined : (
                <p>
                  Acesse as Ações ECOA e inicie a etapa de apreciação. <b>Lembre-se:</b> você precisa apreciar as Ações antes
                  do prazo expirar.
                </p>
              )
            }
            actions={
              <Button variant="solido-destaque" size="sm" onClick={() => navigate('/validar-acao-ecoa')}>
                Apreciar ações ECOA
              </Button>
            }
            note={!isExperied ? <DeadlineNote>{htmlCountdownEvaluation}</DeadlineNote> : appraiserNote}
          >
            {agenda}
          </ProgramSection>
        ) : (
          <ProgramSection
            program="ecoa"
            name="Ações ECOA"
            headline="Não há nenhuma Ação ECOA aguardando apreciação"
            description={<p>Acesse o botão "Acompanhar ações" para visualizar.</p>}
            actions={
              <Button variant="solido-destaque" size="sm" onClick={() => navigate('/validar-acao-ecoa')}>
                Acompanhar ações ECOA
              </Button>
            }
            note={appraiserNote}
          >
            {agenda}
          </ProgramSection>
        ))}

      {/* MEQ2-09: o mesmo seletor da Minha Equipe, no lugar do modal antigo; a fila ECOA lê a matrícula escolhida. */}
      {!!lateralManagers?.length && evaluateActiveCycleObj?.status === 'evaluation' && (
        <ModalEquipeLateral
          isOpen={showModalLateral}
          titulo="Apreciar ações ECOA lateralidade/substituição"
          texto="Escolha o gestor do seu prefixo no lugar de quem você vai apreciar as ações ECOA."
          rotuloDoConfirmar="Apreciar"
          onFechar={() => setShowModalLateral(false)}
          onEscolher={gestor => {
            gravarLateralidade(gestor.chave);
            setShowModalLateral(false);
            navigate('/validar-acao-ecoa');
          }}
        />
      )}
    </>
  );
}

/** Rodapé do integrante: prazo da agenda e, quando houver, as ações do mês (HOME-26). */
export function ecoaFooterNote(deadline: string, registered: number, participations: number) {
  const counts = [
    registered ? `${registered} ${registered === 1 ? 'cadastrada' : 'cadastradas'}` : undefined,
    participations ? `${participations} ${participations === 1 ? 'participação' : 'participações'}` : undefined,
  ].filter(Boolean);

  return [deadline, ...counts].join(' · ');
}
